import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineV = { hidden: { y: "110%" }, show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }) };

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span className={`block ${lineClass}`} variants={lineV} custom={delay + i * 0.12}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const SectionHead = ({ eyebrow, lines, children, testid }) => (
  <div className="max-w-3xl" data-testid={testid}>
    <Reveal><p className="eyebrow mb-6">{eyebrow}</p></Reveal>
    <h2 className="font-display font-black uppercase leading-[0.92] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
      <MaskLines lines={lines} inView lineClass="chrome-text" />
    </h2>
    {children && <Reveal delay={0.2}><div className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed">{children}</div></Reveal>}
  </div>
);
